export const dateUtils = {
  formatMonth: (date: Date | string): string => {
    const d = typeof date === 'string' ? new Date(date) : date;
    return d.toLocaleDateString('en-US', { month: 'short', year: 'numeric', timeZone: 'UTC' });
  },

  formatFullMonth: (date: Date | string): string => {
    const d = typeof date === 'string' ? new Date(date) : date;
    return d.toLocaleDateString('en-US', { month: 'long', year: 'numeric', timeZone: 'UTC' });
  },

  formatDate: (date: Date | string): string => {
    const d = typeof date === 'string' ? new Date(date) : date;
    return d.toLocaleDateString();
  },

  formatDateTime: (date: Date | string): string => {
    const d = typeof date === 'string' ? new Date(date) : date;
    return d.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  },

  toTimestamp: (date: Date | string): number => {
    const d = typeof date === 'string' ? new Date(date) : date;
    return d.getTime();
  },

  sortChronologically: <T extends { monthStart: Date | string }>(data: T[]): T[] => {
    return [...data].sort(
      (a, b) => dateUtils.toTimestamp(a.monthStart) - dateUtils.toTimestamp(b.monthStart),
    );
  },

  isValidDate: (date: Date | string): boolean => {
    const d = typeof date === 'string' ? new Date(date) : date;
    return d instanceof Date && !isNaN(d.getTime());
  },

  currentMonthLabel: (): string => {
    const now = new Date();
    const month = now.toLocaleDateString('en-US', { month: 'long' });
    return `${month} (Current month)`;
  },

  currentMonthName: (): string => {
    const now = new Date();
    return now.toLocaleDateString('en-US', { month: 'short' });
  },
};
